import Header from '../components/Header/HeaderBanner'
import Footer from '../components/Footer'
import heroBanner from '../images/hero-banner-naked.png'

export default function Support() {
  return (
    <div className="h-screen flex flex-col items-center">
      <div className="relative lg:max-w-[1000px] xl:max-w-[1200px] w-full h-full flex flex-col">
        <div className="bg-white grow">
          <Header media={heroBanner} title={''} />
          <div className="font-roboto pt-6 px-1">
            <p className="my-4">
              It looks like you're trying to access a test. Please follow the
              unique link provided in the email you received.
            </p>
            <p className="my-4">
              If you're having issues accessing the link you were provided,
              please contact{' '}
              <a
                className="text-purple-600"
                href="mailto:support.agsm@unsw.edu.au"
              >
                support.agsm@unsw.edu.au
              </a>
            </p>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  )
}
